import React, { Component }  from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import QrReader from 'react-qr-reader'

import LoadingSpinner from 'components/common/LoadingSpinner'
import { dispatchActions } from './qrHandlerRedux'

import Button from 'react-md/lib/Buttons'
import Toolbar from 'react-md/lib/Toolbars'

import './QRHandler.css'

/* TODO: implement legacy mode for ios devices (taking a picture) */

class QRHandler extends Component {
	state = {
		delay: 250
	};

	componentWillUnmount() {
		this.props.resetQRHandler();
	}

	onButtonBack = () => this.props.history.push('/home/token');

	handleLoad = () => this.props.handleQRLoad();

	handleScan = (data) => data && this.props.handleQRData(data);

	handleError = (e) => this.props.handleQRError(e);

	render() {
		const { isLoading, pathname, error } = this.props.qrHandler;

		const redirectParams = {
			pathname,
			state: {
				handler: {
					origin: "/home/qr",
					errorMessage: "Dieser QR-Code ist uns leider nicht bekannt. Bitte versuchen Sie es erneut."
				}
			}
		};

		if (pathname) return <Redirect to={redirectParams} />;

		return (
			<div>
				<Toolbar
					colored
					title="QR-Code scannen"
					nav={<Button key="nav" icon onClick={this.onButtonBack}>arrow_back</Button>}
				/>
				{ isLoading && <LoadingSpinner message="QR-Scanner wird geladen..."/> }
				<div className="qr-container">
					{ !isLoading &&
						<div className="qr-container-title">
							<span>Bitte halten Sie den quadratischen</span> <span>QR-Code des Stickers</span> <span>gut sichtbar in die Kamera:</span>
						</div> }
					<div className="qr-container-scanner" >
						<QrReader
							delay={this.state.delay}
							style={{width: "250px", height: "250px", objectFit: "fill", marginTop: "12px"}}
							onLoad={this.handleLoad}
							onError={this.handleError}
							onScan={this.handleScan}
							facingMode="environment"
						/>
					</div>
				</div>
				{ error && <Redirect to={'/home'} /> }
			</div>
		);
	}
}


const mapStateToProps = (state) => {
	return {
		qrHandler: state.qrHandler
	}
};

export default connect(mapStateToProps, dispatchActions)(QRHandler);


// WEBPACK FOOTER //
// ./src/components/home/qrHandler/QRHandler.jsx